module.exports = __webpack_public_path__ + "img/johnnie_walker_etiqueta_roja_700ml.eff83a38.jpg";